import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonRouterOutlet, IonPage, onIonViewWillEnter } from "@ionic/vue";

import { useRegister } from "@/composables/register";


export default /*#__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const { clearForm } = useRegister();

onIonViewWillEnter(() => {
	clearForm();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})